/***********************************************************************
Use            : To declare the application constant values
Created By     : ATP-0000850
Created Date   : 22-APR-2020
Updated By     : ATP-0000850
Updated Date   : 22-APR-2020
***********************************************************************/
/** Route names */
const RouteAlias = {
    applicantDeclaration: "ApplicantDeclaration",
    conceptNoteDeclaration: "ConceptNoteDeclaration"
};

/** currency settings */
const currency = {
    symbol: 'USD'
}

/** region settings */
const region = {
    default: 'en-US',
    decimalSeparator: '.',
    CurrencyGroupSeparator: ","
}

/** workspace properties */
const workspace = {
    default_menu: 'technicalApplication',
    default_tech_appl_key: 'project',
    default_due_diligence_key: 'organizationinformation',
    default_lang: 'en'
}
const assessmentWorkspace = {
    default_menu: 'dueDiligence',
    budget: 'budget',
    default_dd_review_key: 'organizationinformation',
    default_budget_review_key: 'section3',
    default_lang: 'en'
};

const performanceStatus = [
    { label: "Achieved", value: 1, color: "green" },
    { label: "Partially Achieved", value: 2, color: "yellow" },
    { label: "In progress", value: 3, color: "warning" },
    { label: "Not Achieved", value: 4, color: "red" }
];

const customIndicatorDataTypes = [
    { DisplayText: 'Numeric', Value: 4873 },
    { DisplayText: 'Text', Value: 4877 },
    { DisplayText: 'Yes/No', Value: 4874 }
];

const budgetConclusion = [
    { label: "Accepted", value: 1 },
    { label: "Revisions required", value: 2 },
    { label: "Not recommended", value: 3 }
];

const ddConclusion = [
    { value: 1, label: "Recommend for funding"},
    { value: 2, label: "Recommend for funding, if additional documents/information is provided"},
    { value: 3, label: "Not Recommended for funding"}
]

const entities = {
    conceptNote: "ConceptNote",
    application: "Application",
    grant: "Grant",
    techReport: "TechnicalReport",
    finReport: "FinancialReport",
    revExternal: "ReviewExternal",
    revInternal: "ReviewInternal",
    commReport: "CommunicationReport",
    grantAmendmentDetail: "GrantAmendmentDetail",
};

const internalReviewTemplate = {
    properties: {
        dueDiligence: {
            "title": "DUE DILIGENCE ASSESSMENT",
            "x-class": "dd-assessment"
        },
        budget: {
            "title": "BUDGET ASSESSMENT",
            "x-class": "budget-assessment"
        }
    }
};

const documentTags = {
    grantAgreementTemplate : 29,
    communicationGuidelines: 30,
    projectProfileDraft: 31,
    photos: 32,
    technicalReport: 33,
    finArticles: 34
};

const generalNotifications = {
    coiDisagree: {
        text: 'You have indicated that you may have a Conflict of Interest. Admin will review your comments and notify you of next steps.',
        url: 'dashboard',
        buttonText: 'Back'
    },
    reviewSubmitted: {
        text: 'Review has been submitted successfully.',
        url: 'dashboard',
        buttonText: 'Back to Review'
    },
    intReviewSubmitted: {
        text: 'Review has been submitted successfully.',
        url: 'internalReviews',
        buttonText: 'Back to Review'
    },
    appDeclaration: {
        text: `You have disagreed the application declaration. You can't proceed further.`,
        url: 'dashboard',
        buttonText: 'Back'
    },
    registerSuccess: {
        text: `An account has been created successfully for {Name}. You will receive an e-mail shortly. Please use login information provided in the e-mail to access your account.`,
        url: 'dashboard',
        buttonText: 'Login'
    },
    submittedApplication: {
        text: `Application has been submitted successfully.`,
        url: 'dashboard',
        buttonText: 'Ok',
    },
};

const reportingFrequency = {
    Quartertly: 60,
    HalfYearly: 61,
    Yearly: 62,
};

const migrationsaveStatus=[194]

/** logframework sections */
const migrationLogframeworkSections = {
    "properties": {
        "logFramework": {
            "title": "Log Framework",
            "x-class": "logical-framework"
        },
        "monitoringPlan": {
            "title": "Project Monitoring Plan",
            "x-class": "project"
        }
    }
};

const migrationTechnicalReportSections = {
    "properties": {
        "impact": {
            "title": "Project Impact",
            "x-class": "project-impact"
          },
          "performance": {
            "title": "Project Performance",
            "x-class": "project-performance",
            "properties": {
              "result": {
                "title": "Result & Activities",
                "x-class": "width-33",
                "type": "instance"
              },
              "progress": {
                "title": "Progress during reporting period",
                "x-class": "width-33",
                "type": "boolean",
                "items": [
                  {
                    "label": "Achieved",
                    "value": 1,
                    "color": "green"
                  },
                  {
                    "label": "Partially Achieved",
                    "value": 2,
                    "color": "yellow"
                  },
                  {
                    "label": "In progress",
                    "value": 3,
                    "color": "warning"
                  },
                  {
                    "label": "Not Achieved",
                    "value": 4,
                    "color": "red"
                  }
                ]
              },
              "plans": {
                "title": "Planned for next reporting period",
                "x-class": "width-33",
                "type": "string"
              }
            }
          },
    }
};


/** logframework sections */
const logframeworkSections = {
    "properties": {
        "logFramework": {
            "title": "Log Framework",
            "x-class": "logical-framework"
        },
        "monitoringPlan": {
            "title": "Project Monitoring Plan",
            "x-class": "project"
        },
        "timeline": {
            "title": "Project Timeline",
            "x-class": "project-timeline"
        }
    }
};

const grantSummarySectionsAdmin = {
    "properties": {
        "summary": {
            "title": "Summary",
            "x-class": "logical-framework"
        },
        "grantDocs": {
            "title": "Grant Documents",
            "x-class": "project"
        },
        "techReports": {
            "title": "Technical Reports",
            "x-class": "project-timeline"
        },
        "finReports": {
            "title": "Financial Reports",
            "x-class": "financial-info"
        },
        "activityLog": {
            "title": "Activity Log",
            "x-class": "project-timeline"
        }
    }
};

const grantSummarySections = {
    "properties": {
        "summary": {
            "title": "Summary",
            "x-class": "logical-framework"
        },
        "grantDocs": {
            "title": "Grant Documents",
            "x-class": "project"
        },
        "techReports": {
            "title": "Technical Reports",
            "x-class": "project-timeline"
        },
        "finReports": {
            "title": "Financial Reports",
            "x-class": "financial-info"
        },
        "communication": {
            "title": "Communication",
            "x-class": "communications"
        },
        "grantAmendment": {
            "title": "Amendments",
            "x-class": "grant-amendment"
        },
        "activityLog": {
            "title": "Activity Log",
            "x-class": "project-timeline"
        }
    }
};

const grantAgreementSections = {
    "properties": {
        "information": {
            "title": "Grant Information",
            "x-class": "logical-framework"
        },
        "agreementDocuments": {
            "title": "Grant Agreement Documents",
            "x-class": "project"
        },
        "techReportingPeriod": {
            "title": "Technical Reporting Period",
            "x-class": "project-timeline"
        },
        "finReportingPeriod": {
            "title": "Financial Reporting Period",
            "x-class": "financial-info"
        },
        "sign": {
            "title": "Sign",
            "x-class": "logical-framework"
        }
    }
};

const budgetReportSections = {
    "properties": {
        "allocationReports": {
            "title": "Allocation Reports",
            "x-class": "project"
        },
        "progressReport": {
            "title": "Implementation Progress Reports",
            "x-class": "project-timeline"
        }
    }
};

const templateSections = {
    "logFramework": {
      "title": "Log Framework",
      "x-class": "logical-framework"
    },
    "monitoringPlan": {
      "title": "Project Monitoring Plan",
      "x-class": "project"
    },
    "timeline": {
      "title": "Project Timeline",
      "x-class": "project-timeline"
    }
  };
 
const logicalFrameworkHeaders = {
    "logFramework": {
      "title": "Logical Framework",
      "properties": {
        "result": {
          "x-virtual": true,
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "prefix-en": {
                "type": "string",
                "title": "R",
                "x-display": "hidden"
              },
              "description-en": {
                "type": "string",
                "title": "Results"
              },
              "prefix-fr": {
                "type": "string",
                "title": "R",
                "x-display": "hidden"
              },
              "description-fr": {
                "type": "string",
                "title": "Résultats"
              },
              "prefix-es": {
                "type": "string",
                "title": "SO",
                "x-display": "hidden"
              },
              "description-es": {
                "type": "string",
                "title": "Objetivos específicos"
              },
              "deliverables": {
                "type": "array",
                "items": {
                  "type": "object",
                  "properties": {
                    "prefix-en": {
                      "type": "string",
                      "title": "O",
                      "x-display": "hidden"
                    },
                    "description-en": {
                      "type": "string",
                      "title": "Outputs"
                    },
                    "prefix-fr": {
                        "type": "string",
                        "title": "O",
                        "x-display": "hidden"
                      },
                    "description-fr": {
                        "type": "string",
                        "title": "Livrables"
                    },
                    "prefix-es": {
                        "type": "string",
                        "title": "R",
                        "x-display": "hidden"
                    },
                    "description-es": {
                        "type": "string",
                        "title": "Resultados"
                    },
                    "activities": {
                      "type": "array",
                      "items": {
                        "type": "object",
                        "properties": {
                          "prefix-en": {
                            "type": "string",
                            "title": "A",
                            "x-display": "hidden"
                          },
                          "description-en": {
                            "type": "string",
                            "title": "Activities"
                          },
                          "prefix-fr": {
                            "type": "string",
                            "title": "A",
                            "x-display": "hidden"
                          },
                          "description-fr": {
                            "type": "string",
                            "title": "Activités"
                          },
                          "prefix-es": {
                            "type": "string",
                            "title": "A",
                            "x-display": "hidden"
                          },
                          "description-es": {
                            "type": "string",
                            "title": "Actividades"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };

const transactionHeaders = [
    { text: 'Invoice number', width: 100, sortable: true, value: 'invoiceNo', class: 'invoiceNo'  },
    { text: 'Invoice date', width: 100, sortable: true, value: 'invoiceDate', class: 'invoiceDate'  },
    { text: 'Budget category',  width: 200, sortable: false, value: 'budgetCategory', class: 'budgetCategory'  },
    { text: 'Budget line',  width: 200, sortable: false, value: 'budgetLine', class: 'budgetLine'  },
    { text: 'Description',  width: 200, sortable: false, value: 'description', class: 'description'  },
    { text: 'Invoice amount',  width: "15%", sortable: false, value: 'invAmtNatCurrency', align:'end', class: 'invAmtNatCurrency'  },
    { text: 'Denomination',  width: "15%", sortable: false, value: 'denomination', align:'end', class: 'denomination'  },
    { text: 'Exchange rate',  width: 30, sortable: false, value: 'exchRate', align:'end', class: 'exchRate'  },
    { text: 'Amount in EUR',  width: "15%", sortable: false, value: 'totalAmount', align:'end', class: 'totalAmount'  },
    { text: "", value: "action", sortable: false, width: 30 }
];

const personnelHeaders = [
    { text: 'Budget line',  width: 200, sortable: false, value: 'budgetLine', class: 'budgetLine'  },
    { text: 'Employee name',  width: "20%", sortable: true, value: 'empName', class: 'empName'  },
    { text: 'Gross salary',  width: "15%", sortable: false, value: 'grossSalary', align:'end', class: 'grossSalary'  },
    { text: 'Social charges',  width: "15%", sortable: false, value: 'otherCost', align:'end', class: 'otherCost'  },
    { text: 'Total costs',  width: "15%", sortable: false, value: 'totCost', align:'end', class: 'totCost'  },
    { text: 'Currency of payment',  width: "15%", sortable: false, value: 'currency', align:'end', class: 'currency'  },
    { text: 'Exchange rate',  width: 30, sortable: false, value: 'exchRate', align:'end', class: 'exchRate'  },
    { text: 'Total costs in EUR',  width: "20%", sortable: false, value: 'totCostEUR', align:'end', class: 'totCostEUR'  },
    { text: 'Hours worked',  width: "15%", sortable: false, value: 'workHours', align:'end', class: 'workHours'  },
    { text: 'Hourly rate',  width: "15%", sortable: false, value: 'hourlyRate', align:'end', class: 'hourlyRate'  },
    { text: 'Hours worked for the project',  width: "15%", sortable: false, value: 'totalHours', align:'end', class: 'totalHours'  },
    { text: 'Cost charged',  width: "15%", sortable: false, value: 'costCharged', align:'end', class: 'costCharged'  },
    { text: "", value: "action", sortable: false, width: 50 }
];


/** application templates */
const templates = {
    techApp: 'technicalApplication',
    budget: 'applicationBudget',
    dueDelig: 'applicantDueDeligence',
    submit: 'submit'
}

/** indicator mapping table headers */
const indicatorMappingHeaders: any = [
    { text: 'Indicator', align: 'center', sortable: false, value: 'IndicatorId' },
    { text: 'Unit', align: 'center', sortable: false, value: 'Unit' },
    { text: 'Periodicity', align: 'center', sortable: false, value: 'Periodicity' },
    { text: "", value: "action", sortable: false, width: 50 }
]

/** ME Entity table headers */
const meEntityHeaders: any = [
    { text: 'Goal', align: 'center', width: "30%", sortable: false, value: 'goal' },
    { text: 'Objective', align: 'center', width: "30%", value: 'objective' },
    { text: 'Categories', align: 'center', width: "30%", value: 'categories' },
    { text: "", value: "action", sortable: false, width: 50 }
];
const usefulDocHeaders: any = [
    { text: 'Program', value: "Program", sortable: false,width:"5%"},
    { text: 'Initiative', value: "Initiative", sortable: false,width:"40%"},
    {text: 'Documet type' , value:'Doctype',sortable:false,width:"30%"},
    {text: 'Document' , value:'Link',sortable: false,width:"25%"}
];
const docHeaders: any = [
    { text: 'Document Type', sortable: true, value: 'TagName'  },
    { text: 'Section',  width: "15%", sortable: false, value: 'Section'  },
    { text: 'Document',  width: "35%", sortable: false, value: 'FileName'  },
    { text: 'Uploaded Date (UTC)', width: "18%", sortable: true, value: 'CreatedDate' },
    { text: "", value: "action", sortable: false, width: 10 }
];
const archiveHeaders: any = [
    { text: 'Program', value: "Program", sortable: false,width:"5%"},
    { text: 'Initiative', value: "Initiative", sortable: false,width:"200px"},
    { text: 'Call name', value: "CallName", sortable: false,width:"400px"},
    { text: 'Start Date', value: "StartDate", sortable: false,width:"5%"},
    { text: 'End Date', value: "EndDate", sortable: false,width:"5%"},
    { text: 'Budget', value: "Budget", sortable: false,width:"5%"},
    { text: 'Funded by', value: "FundedBy", sortable: false,width:"400px"},
    { text: 'Awarded grants',value:"AwardedGrantsDocument", sortable: false,align:"center",class:'archive-header'},
    { text: 'Guidelines for applicants', value:"GuidelinesForApplicants",sortable: false,align:"center",class:'archive-header'},
    { text: 'Corrigendum', value:"Corrigendum",sortable: false,align:"center",class:'archive-header'},
    { text: 'FAQ', value: "FAQ", sortable: false,align:"center",class:'archive-header'}
];

const archiveHeadersAdmin: any = [
    { text: 'Program', value: "Program", sortable: false},
    { text: 'Initiative', value: "Initiative", sortable: false },
    { text: 'Call Name', value: "CallName", sortable: false },
    { text: 'Start Date', value: "StartDate", sortable: false, width:"30px" },
    { text: 'End Date', value: "EndDate", sortable: false, width:"30px" },
    { text: 'Budget', value: "Budget", sortable: false, align:"end",width:"60px"},
    { text: 'Funded By', value: "FundedBy", sortable: false },
    { text:'Published', value: "ShowPublic", sortable: false },
    { text: '', value: "Action", sortable: false },
];
const archiveCreateHeaders: any = [
    {
        text: "Call Name",
        value: "CallName",
        sortable: false,
        type: "textFeild",
        rules: [(v) => !!v || ""],
      },
      {
        text: "Start Date",
        value: "StartDate",
        sortable: false,
        type: "DateFeild",
        rules: [(v) => !!v || ""],
      },
      {
        text: "End Date",
        value: "EndDate",
        sortable: false,
        type: "DateFeild",
        rules: [(v) => !!v || ""],
      },
      {
        text: "Funded By ",
        value: "FundedBy",
        sortable: false,
        type: "textFeild",
        rules: [(v) => !!v || ""],
      },
      {
        text: "Programme",
        value: "ProgramId",
        sortable: false,
        type: "DropDown",
        items: [],
        rules: [(v) => !!v || ""],
      },
      {
        text: "Initiative",
        value: "Initiative",
        sortable: false,
        type: "textFeild",
        rules: [(v) => !!v || ""],
      },
      {
        text: "Budget",
        value: "Budget",
        sortable: false,
        type: "textFeild",
        rules: [(v) => !!v || ""]
        //inputType:"number"
      },
      {
        text: "Budget Currency",
        value: "BudgetCurrencyId",
        sortable: false,
        type: "DropDown",
        items: [],
        rules: [(v) => !!v || ""],
      },
      {
        text: "Guidelines For Applicants",
        value: "GuidelinesForApplicants",
        sortable: false,
        type: "textFeild",
        rules: [],
      },
      {
        text: "Corrigendum",
        value: "Corrigendum",
        sortable: false,
        type: "textFeild",
        rules: [],
      },
      {
        text: "FAQ",
        value: "FAQ",
        sortable: false,
        type: "textFeild",
        rules: [],
      },
      {
        text: "Awarded Grants Document",
        value: "AwardedGrantsDocument",
        sortable: false,
        type: "textFeild",
        rules: [],
      },
      {
        text: "Language",
        value: "Language",
        sortable: false,
        type: "DropDown",
        items: [{ DisplayText: "English",Value:"en-US" }, {DisplayText: "French",Value:"fr-FR" }],
        rules: [(v) => !!v || ""],
      },
      {
        text: "Publish",
        value: "ShowPublic",
        sortable: false,
        type: "switch",
        rules: [],
      },
];
const updatearchiveHeaders: any = [
    {
        text: "Call Name",
        value: "CallName",
        sortable: false,
        type: "textFeild",
        rules: [(v) => !!v || ""],
      },
      {
        text: "Start Date",
        value: "StartDate",
        sortable: false,
        type: "DateFeild",
        rules: [(v) => !!v || ""],
      },
      {
        text: "End Date",
        value: "EndDate",
        sortable: false,
        type: "DateFeild",
        rules: [(v) => !!v || ""],
      },
      {
        text: "Funded By ",
        value: "FundedBy",
        sortable: false,
        type: "textFeild",
        rules: [(v) => !!v || ""],
      },
      {
        text: "Programme",
        value: "ProgramId",
        sortable: false,
        type: "DropDown",
        items: [],
        rules: [(v) => !!v || ""],
      },
      {
        text: "Initiative",
        value: "Initiative",
        sortable: false,
        type: "textFeild",
        rules: [(v) => !!v || ""],
      },
      {
        text: "Budget",
        value: "Budget",
        sortable: false,
        type: "textFeild",
        rules: [(v) => !!v || ""]
        //inputType:"number"
      },
      {
        text: "Budget Currency",
        value: "BudgetCurrencyId",
        sortable: false,
        type: "DropDown",
        items: [],
        rules: [(v) => !!v || ""],
      },
      {
        text: "Guidelines For Applicants",
        value: "GuidelinesForApplicants",
        sortable: false,
        type: "textFeild",
        rules: [],
      },
      {
        text: "Corrigendum",
        value: "Corrigendum",
        sortable: false,
        type: "textFeild",
        rules: [],
      },
      {
        text: "FAQ",
        value: "FAQ",
        sortable: false,
        type: "textFeild",
        rules: [],
      },
      {
        text: "Awarded Grants Document",
        value: "AwardedGrantsDocument",
        sortable: false,
        type: "textFeild",
        rules: [],
      },
      {
        text: "Language",
        value: "Language",
        sortable: false,
        type: "DropDown",
        items: [{ DisplayText: "English",Value:"en-US" }, {DisplayText: "French",Value:"fr-FR" }],
        rules: [(v) => !!v || ""],
      },
      {
        text: "Publish",
        value: "ShowPublic",
        sortable: false,
        type: "switch",
        rules: [],
      },
];

/** admin summary for application documents */
const docListHeaders: any = [
    { text: 'Document Type', sortable: true, value: 'TagName'  },
    { text: 'Section',  width: "15%", sortable: false, value: 'Section'  },
    { text: 'Document',  width: "35%", sortable: false, value: 'FileName'  },
    { text: 'Uploaded Date (UTC)', width: "18%", sortable: true, value: 'CreatedDate' },
    { text: "", value: "action", sortable: false, width: 10 }
];

const reportingPeriodHeaders: any = [
    { text: 'Title', width: "20%", sortable: true, value: 'Description'  },
    { text: 'Start date', width: "17%", sortable: true, value: 'StartDate'  },
    { text: 'End date',  width: "17%", sortable: false, value: 'EndDate'  },
    { text: 'Due on',  width: "17%", sortable: false, value: 'DueDate'  },
    { text: 'Status',  width: "20%", sortable: false, value: 'StepName'  },
    { text: "", value: "action", sortable: false, width: 50 }
];

const communicationPeriodHeaders: any = [
    { text: 'Title', width: "25%", sortable: true, value: 'Description'  },
    { text: 'Start date', width: "20%", sortable: true, value: 'StartDate'  },
    { text: 'End date',  width: "20%", sortable: false, value: 'EndDate'  },
    { text: 'Status',  width: "22%", sortable: false, value: 'Status'  }
];

const reportScheduleHeaders: any = [
    { text: 'Title', width: "20%", sortable: true, value: 'Title'  },
    { text: 'Start date', width: "20%", sortable: true, value: 'StartDate'  },
    { text: 'End date',  width: "20%", sortable: false, value: 'EndDate'  },
    { text: 'Due on',  width: "20%", sortable: false, value: 'DueDate'  },
    { text: 'Status',  width: "20%", sortable: false, value: 'Status'  }
];

const commiunicationReportHeaders: any = [
    {
        text: "Initiative",
        value: "Initiative",
        sortable: false,
        type: "DropDownComponent",
        items: [],
        rules: [(v) => !!v || ""],
      },
      {
        text: "Call",
        value: "InitiativeCallId",
        sortable: false,
        type: "DropDownComponent",
        items: [],
        rules: [(v) => !!v || ""],
      },
      {
        text: "Template",
        value: "CommunicationTemplateId",
        sortable: false,
        type: "DropDownComponent",
        items: [],
        rules: [(v) => !!v || ""],
      },
      {
        text: "Steps",
        value: "Steps",
        sortable: false,
        type: "MultiSelectComponent",
        items: [],
        rules: [(v) => !!v || ""],
      },
      {
        text: "Stories",
        value: "Stories",
        sortable: false,
        type: "MultiSelectComponent",
        items: [],
        rules: [(v) => !!v || ""],
      },
];

const commiunicationHeadersAdmin: any = [
    { text: 'Initiative', value: "Initiative", sortable: false,width:"25%"},
    { text: 'Call', value: "InitiativeCall", sortable: false,width:"25%"},
    { text: 'Template', value: "Template", sortable: false,width:"25%"},
    { text: 'Steps', value: "Steps", sortable: false,width:"25%"},
    { text: 'Stories', value: "Stories", sortable: false,width:"25%"},
    { text: '', value: "Action", sortable: false },
];

const subjects = {
    all: 'all',
    application: 'application',
    applicationReadonly: 'applicationReadonly',
    externalReview: 'externalReview',
    initiative: 'initiative',
    internalReview: 'internalReview',
    program: 'program',
    secretariatMember: 'secratriat',
    donor: 'donor',
    ragReview: 'ragReview',
    grant: 'grant',
    grantDocs: 'grantDocs',
    feedback: 'feedback',
    grantAgree: 'grantAgree',
    grantReports: 'grantReports',
    techReport: 'techReport',
    finReport: 'finReport',
    finReportAudit: 'finReportAudit',
    ppo: 'ppo',
    genericFeedback: 'genericFeedback',
    viewsnapshot: 'viewsnapshot',
    periodEdit:'periodEdit',
    grantReportApprove: 'grantReportApprove',
    communication: 'commmunication',
    migrationImport:'migrationImport',
    ownershipChange: 'ownershipChange',
    conceptNote: 'conceptNote',
    amendment: 'amendment',
    noCostAmendment: 'noCostAmendment',
    budgetAmendment: 'budgetAmendment',
    technicalAmendment: 'technicalAmendment',
    suspension: 'suspension',
    termination: 'termination',
    resumeGrant: 'resume'
};

const actions = {
    manage: 'manage',
    fullaccess: 'fullaccess',
    read: 'readonly',
    create: 'create',
    delete: 'delete',
    update: 'update'
};

const roles = [
    { subject: subjects.all, action: actions.fullaccess, roleId: "1"},
    { subject: subjects.all, action: actions.fullaccess, roleId: "2"},
    { subject: subjects.program, action: actions.manage, roleId: "3"},
    { subject: subjects.ragReview, action: actions.read, roleId: "3"},
    { subject: subjects.grant, action: actions.read, roleId: "3"},
    { subject: subjects.secretariatMember, action: actions.manage, roleId: "4"},
    { subject: subjects.ragReview, action: actions.read, roleId: "4"},
    { subject: subjects.grant, action: actions.read, roleId: "4"},
    { subject: subjects.application, action: actions.manage, roleId: "6"},
    { subject: subjects.externalReview, action: actions.manage, roleId: "7"},
    { subject: subjects.donor, action: actions.manage, roleId: "8"},
    { subject: subjects.internalReview, action: actions.manage, roleId: "10"},
    { subject: subjects.initiative, action: actions.manage, roleId: "13"},
    { subject: subjects.ragReview, action: actions.create, roleId: "14"},
    { subject: subjects.feedback, action: actions.manage, roleId: "1"},
    { subject: subjects.feedback, action: actions.manage, roleId: "2"},
    { subject: subjects.feedback, action: actions.manage, roleId: "3"},
    { subject: subjects.feedback, action: actions.manage, roleId: "4"},
    { subject: subjects.feedback, action: actions.manage, roleId: "16"},
    { subject: subjects.applicationReadonly, action: actions.read, roleId: "4"},
    { subject: subjects.grantAgree, action: actions.manage, roleId: "1"},
    { subject: subjects.grantAgree, action: actions.manage, roleId: "2"},
    { subject: subjects.grantAgree, action: actions.manage, roleId: "3"},
    { subject: subjects.grantReports, action: actions.read, roleId: "1"},
    { subject: subjects.grantReports, action: actions.read, roleId: "2"},
    { subject: subjects.grantReports, action: actions.read, roleId: "3"},
    { subject: subjects.grantReports, action: actions.read, roleId: "16"},
    { subject: subjects.grantReportApprove, action: actions.update, roleId: "1"},
    { subject: subjects.grantReportApprove, action: actions.update, roleId: "2"},
    { subject: subjects.grantReportApprove, action: actions.update, roleId: "3"},
    { subject: subjects.grantReportApprove, action: actions.update, roleId: "16"},
    { subject: subjects.grantReportApprove, action: actions.update, roleId: "18"},
    { subject: subjects.periodEdit, action: actions.manage, roleId: "1"},
    { subject: subjects.periodEdit, action: actions.manage, roleId: "2"},
    { subject: subjects.periodEdit, action: actions.manage, roleId: "3"},
    { subject: subjects.grantReports, action: actions.update, roleId: "6"},
    { subject: subjects.grantReports, action: actions.read, roleId: "4"},
    { subject: subjects.grantDocs, action: actions.update, roleId: "1"},
    { subject: subjects.grantDocs, action: actions.update, roleId: "2"},
    { subject: subjects.grantDocs, action: actions.update, roleId: "3"},
    { subject: subjects.grantDocs, action: actions.update, roleId: "13"},
    { subject: subjects.grantDocs, action: actions.update, roleId: "15"},
    { subject: subjects.ppo, action: actions.update, roleId: "3"},
    { subject: subjects.ppo, action: actions.update, roleId: "2"},
    { subject: subjects.genericFeedback, action: actions.manage, roleId: "1"},
    { subject: subjects.genericFeedback, action: actions.manage, roleId: "2"},
    { subject: subjects.genericFeedback, action: actions.manage, roleId: "3"},
    { subject: subjects.genericFeedback, action: actions.manage, roleId: "4"},
    { subject: subjects.viewsnapshot, action: actions.manage, roleId: "1"},
    { subject: subjects.viewsnapshot, action: actions.manage, roleId: "2"},
    { subject: subjects.viewsnapshot, action: actions.manage, roleId: "3"},
    { subject: subjects.finReport, action: actions.update, roleId: "6"},
    { subject: subjects.finReport, action: actions.read, roleId: "6"},
    { subject: subjects.finReport, action: actions.read, roleId: "16"},
    { subject: subjects.finReport, action: actions.read, roleId: "4"},
    { subject: subjects.finReport, action: actions.read, roleId: "2"},
    { subject: subjects.finReport, action: actions.read, roleId: "3"},
    { subject: subjects.finReportAudit, action: actions.update, roleId: "16"},
    { subject: subjects.communication, action: actions.manage, roleId: "1"},
    { subject: subjects.communication, action: actions.manage, roleId: "2"},
    { subject: subjects.communication, action: actions.manage, roleId: "3"},
    { subject: subjects.communication, action: actions.manage, roleId: "4"},
    { subject: subjects.communication, action: actions.create, roleId: "6"},
    { subject: subjects.communication, action: actions.create, roleId: "19"},
    { subject: subjects.migrationImport, action: actions.create, roleId: "2"},
    { subject: subjects.migrationImport, action: actions.create, roleId: "4"},
    { subject: subjects.ownershipChange, action: actions.update, roleId: "2"},
    { subject: subjects.conceptNote, action: actions.manage, roleId: "6"},
    { subject: subjects.amendment, action: actions.manage, roleId: "2"},
    { subject: subjects.amendment, action: actions.manage, roleId: "3"},
    { subject: subjects.noCostAmendment, action: actions.manage, roleId: "2"},
    { subject: subjects.noCostAmendment, action: actions.manage, roleId: "3"},
    { subject: subjects.noCostAmendment, action: actions.read, roleId: "6"},
    { subject: subjects.budgetAmendment, action: actions.manage, roleId: "2"},
    { subject: subjects.budgetAmendment, action: actions.manage, roleId: "3"},
    { subject: subjects.budgetAmendment, action: actions.update, roleId: "6"},
    { subject: subjects.technicalAmendment, action: actions.manage, roleId: "2"},
    { subject: subjects.technicalAmendment, action: actions.manage, roleId: "3"},
    { subject: subjects.technicalAmendment, action: actions.update, roleId: "6"},
    { subject: subjects.suspension, action: actions.manage, roleId: "2"},
    { subject: subjects.suspension, action: actions.manage, roleId: "3"},
    { subject: subjects.suspension, action: actions.read, roleId: "6"},
    { subject: subjects.termination, action: actions.manage, roleId: "2"},
    { subject: subjects.termination, action: actions.manage, roleId: "3"},
    { subject: subjects.termination, action: actions.read, roleId: "6"},
    { subject: subjects.resumeGrant, action: actions.manage, roleId: "2"},
    { subject: subjects.resumeGrant, action: actions.manage, roleId: "3"},
    { subject: subjects.resumeGrant, action: actions.read, roleId: "6"}
];

const appRoles = {
    SuperAdmin: "1",
    SystemAdmin: "2",
    ProgramAdmin: "3",
    SecretariatMember: "4",
    Applicant: "6",
    Reviewer: "7",
    Donor: "8",
    GPOU: "10",
    InitiativeAdmin: "13",
    RagReviewer: "14",
    MEAdmin: "15",
    Auditor: "16",
    ProgramOfficer: "17",
    ReportValidator: "18",
    CommunicationOfficer: "19"
};

const templateMgrHeader = [
    { text: 'Name', align: 'left', width: "25%", sortable: true, value: 'Name' },
    { text: 'Description', align: 'left', width: "25%", sortable: false, value: 'Description' },
    { text: 'Template Name', align: 'left', width: "25%", sortable: false, value: 'TemplateName' },
    { text: 'Type', align: 'left', width: "15%", sortable: false, value: 'Type' },
    { text: "", value: "action", sortable: false, width: 10, align: 'end' }
]

const reportingPeriods = {
    technical: 6,
    financial: 6
};

const programs = {
    sos: 2,
    tiger: 3
}

const menu = {
    grant: 93,
    application: 73,
    conceptNote: 118,
    techReport: 94,
    finReport: 95,
    communication: 105,
    callforProposal: 37,
    callforProposalForm: 38,
    callforConceptNote: 111,
    callforConceptNoteForm: 112,
    grantAmendment: 121
};
const appUserType = {
    System: 'System',
    SystemAdmin: 'System Admin',
    Secretariat: 'Secretariat',
    LeadPartner: 'Lead Partner',
    TAGReviewer: 'TAG Reviewer',
    Donor: 'Donor',
    Auditor: 'Auditor'
};

const UserType = {
    SystemAdmin: 7,
    Secretariat: 9,
    LeadPartner: 10,
    TAGReviewer: 17,
    Auditor: 18
};

const grantType = {
    RAG: 111,
    TSG: 112
}

const reviewStatus = {
    In_Progress: 142,
    Submitted: 144,
    COI_Rejected: 143,
    Internal_In_Progress: 146,
    Internal_Submitted: 147
};

const updatePPO = {
    submit:['SLT', 'REJ', 'DDRF', 'AWD', 'WNRP', 'WNRV', 'SHLT', 'SFDA', 'DAF', 'INV']
};

const applicationStatus = {
    draft: 131,
    submitted: 132,
    RAGdraft: 148,
    RAGsubmitted: 149,
    negotiationResponse: 153,
    ragNegotiationResponse: 192
};

const workflowStatusCode = {
    draft: ['DFT'],
    submitted: [ 'STD', 'SBMT' ],
    nogotiationResponse: [ 'WNRP' ]
};

const conceptNoteStatus = {
    draft: 195,
    submitted: 196,
    negotiationResponse: 203,
    // RAGdraft: 148,
    // RAGsubmitted: 149,
    // ragNegotiationResponse: 192
};

const grantStatus = {
    awarded: 157,
    signed: 158,
    monitor: 159,
    closeInProgress: 160,
    close: 161,
    suspended: 247,
    terminated: 248
};

const applicantEdiatableStatus = [131, 148, 153, 155, 192, 195, 203];
const appicantEditableStatusCode = [ 'DFT', 'FRP', 'WNRP' ]
const internalReviewAllowedStatus = [ 'ELG', 'RDD', 'RFR', 'SLT', 'WNRP', 'WNRV',  'SFDA' ]

const applicantDeleteStatus = [131, 148];
const applicationAwardedStatus = [141, 165];
const reviewExternalRollbackStatus = 'ELG';
const reviewInternalRollbackStatus = 'RFR';
const reviewInternalConceptNoteRollbackStatus = 'RDD';

/** technical report status */
const techReportStatus = {
    notStarted: 173,
    inProgress: 174,
    pendingReview: 175,
    waitingLP: 176,
    approved: 177,
    readyForValidation: 178,
    terminated: 249
};

const commReportStatus = {
    inProgress: 189,
    completed: 190
};

/** financial report status */
const finReportStatus = {
    notStarted: 167,
    inProgress: 168,
    pendingReview: 169,
    waitingLP: 170,
    readyForAudit: 171,
    approved: 172,
    readyForValidation: 179,
    terminated: 250
}

const finReportAuditStatus = {
    notStarted: 180,
    inProgress: 181,
    pendingReview: 182,
    readyForAudit: 183,
    approved: 184,
    validated: 185,
    terminated: 251
}

const migrationImportStatus = {
    notStarted: 193,
    imported: 194
};

const languages = [
    { value: 1, text: "English" },
    { value: 2, text: "French" },
    { value: 3, text: "Spanish" }
];


const budgetFootnoteKeys = ["coFinDesc"];

const applicantDeclarationText = `The applicant, represented by the undersigned, being the authorized signatory of the applicant, in the context of the present call for proposals, hereby declares that:<br/>- the applicant has sufficient financial capacity to carry out the proposed action or work programme; <br/>- the applicant certifies the legal statutes of the applicant as reported in the application; <br/>- the applicant has the professional competences and qualifications specified in the Detailed Instructions for Applicants; <br/>- the applicant undertakes to comply with the principles of good partnership practice; <br/>- the applicant is directly responsible for the preparation, management, and implementation of the project and is not acting as an intermediary; <br/>- The applicant is not in any of the situations excluding them from participating in contracts which are listed below.<br/> Furthermore, it is recognized and accepted that if the applicant participates in spite of being in any of these situations, they may be excluded from other contracts`;

const TagReviewDeclarationText = `<p>This Conflict of Interest Form should indicate whether the Evaluator has an economic interest in, or acts as an officer or a director of, any outside entity whose financial interests would reasonably appear to be affected by the award of the contract in relation to which bids are being evaluated. The Evaluator should also disclose any personal, business, or volunteer affiliations that may give rise to a real or apparent conflict of interest. Individuals with a conflict of interest should take no part in the evaluation.</p><p>In exceptional cases where an individual needs to take part in the evaluation despite having a real or apparent conflict of interest (for example due to their specialist technical expertise), approval from the Procurement Panel is required.</p><p>Conflicts of Interest include, but are not limited to, the following:</p><ul><li>Directly or indirectly received salary payments, loans, gifts of any kind or any free service, discounts or other fees from one or more bidder</li>
<li>Owner, shareholder or board member of one or more bidder</li><li>Family relationship with anyone who has a noted relationship with one or more bidder (family relationship includes spouse, parent, child, grandparent, grandchild, great-grandchild, sibling, spouse of children, grandchildren, great-grandchildren and siblings)</li></ul>`;

/** default call deadline duration setting */
const Deadlines = {
    Call: 30,
    Review: 30
};

const migrationGrantStatus = {
    open : 131,
    closed: 30
};

const migrationStatus = {
    notStarted : 193,
    imported: 194
};

const budgetMenuButtons = [
    {
      "key": "Budget",
      "type": "import",
      "title": "Import"
    },
    {
      "key": "budgetData",
      "type": "export",
      "title": "Export",
      "x-file-name": ""
    },
    {
      "key": "template",
      "type": "download",
      "title": "Generate Template",
      "x-file-name": ""
    }
];

/** file size limit setting */
const FileSizeLimit = 100;

const defaultTimeFormat = {
    date: "DD/MM/YYYY",
    time: "DD/MM/YYYY HH:mm",
    standard: "UTC"
};

const InitiativeCallType = [
    {Text : "Call for Proposals", TypeId : 63, RouteName: RouteAlias.applicantDeclaration, title:'ApplicantDeclarationHeading'},
    {Text : "Call for Concept Notes", TypeId : 64, RouteName: RouteAlias.conceptNoteDeclaration, title:'ConceptNoteDeclarationHeading'}
];

const callType = {
    conceptNote: 64,
    fullProposal: 63
};

const preferredLanguage = {
    English: 4906,
    French: 4907    
}; 

const amendmentSections = {
    "properties": {
        "summary": {
            "title": "Summary",
            "x-class": "logical-framework"
        },
        "amendmentRequests": {
            "title": "Amendment Types",
            "x-class": "financial-info"
        },
        "sign": {
            "title": "Sign",
            "x-class": "project-timeline"
        },
    }
};
const amendmentSubSections = {
    "properties": {
        "noCost": {
            "title": "Duration Modification",
            "x-class": "noCost"
        },
        // "budgetRevision": {
        //     "title": "Budget Modification",
        //     "x-class": "budgetRevision"
        // },
        // "technicalRevision": {
        //     "title": "Technical Modification",
        //     "x-class": "technicalRevision"
        // }
    }
};

const amendmentTypes = [
    { title: "Duration Modification", value: 4899, type: 'NoCost', group: 'Amendment' },
    { title: "Budget Modification", value: 4900, type: 'Budget', group: 'Amendment' },
    { title: "Technical Modification", value: 4901, type: 'Technical', group: 'Amendment' },
    { title: "Suspension", value: 4903, type: 'Suspend', group: 'Suspension' },
    { title: "Termination", value: 4904, type: 'Terminate', group: 'Termination' },
    { title: "Resume", value: 4905, type: 'Resume', group: 'Resume' }
];

const grantActionItems = [
    { title: "Amendment", value: 1, icon: "" },
    { title: "Suspend", value: 2, icon: "" },
    { title: "Terminate", value: 3, icon: "" },
    { title: "Resume", value: 4, icon: "" }
];

const amendmentHeaders: any = [
    // { text: '#', width: "15%", sortable: true, value: 'Code'  },
    { text: 'Revision #',  width: "10%", sortable: true, value: 'RevisionNo'  },
    { text: 'Amendment Types', width: "35%", sortable: false, value: 'AmendmentType'  },
    { text: 'Requested date', width: "15%", sortable: true, value: 'CreatedDate'  },
    { text: 'Agreement date', width: "15%", sortable: true, value: 'AgreementDate'  },
    { text: 'Status',  width: "25%", sortable: false, value: 'StepName'  },
    { text: '', value: "action", sortable: false }
];

const amendmentDetailsHeaders: any = [
    { text: 'Amendment type',  width: "30%", sortable: false, value: 'AmendmentType'  },
    { text: 'Requested date', width: "30%", sortable: true, value: 'CreatedDate'  },
    { text: 'Status',  width: "30%", sortable: false, value: 'StepName'  },
    { text: '',  width: "5", value: "action", sortable: false }
];

export class AppConstants {

    public static get budgetFootnoteKeys() {
        return budgetFootnoteKeys;
    }
    public static get entities() {
        return entities;
    }

    public static get languages() {
        return languages;
    }
    
    public static get currency() {
        return currency;
    }
    
    public static get region() {
        return region;
    }

    public static get workspace() {
        return workspace;
    }
    public static get programs() {
        return programs;
    }
    public static get assessmentWorkspace() {
        return assessmentWorkspace;
    }
    public static get documentTags() {
        return documentTags;
    }
    public static get templateMgrHeader() {
        return templateMgrHeader;
    }
    public static get reviewStatus() {
        return reviewStatus;
    }
    public static get templates() {
        return templates;
    }
    public static get indicatorMappingHeaders() {
        return indicatorMappingHeaders;
    }
    public static get meEntityHeaders() {
        return meEntityHeaders;
    }
    public static get customIndicatorDataTypes() {
        return customIndicatorDataTypes;
    }
    public static get docHeaders() {
        return docHeaders;
    }
    public static get archiveHeaders()
    {
        return archiveHeaders;
    }
    public static get archiveCreateHeaders()
    {
        return archiveCreateHeaders;
    }
    public static get updatearchiveHeaders()
    {
        return updatearchiveHeaders;
    }
    public static get docListHeaders() {
        return docListHeaders;
    }
    public static get reportingPeriodHeaders() {
        return reportingPeriodHeaders;
    }     
    public static get reportScheduleHeaders() {
        return reportScheduleHeaders;
    }
    public static get generalNotifications() {
        return generalNotifications;
    }
    public static get applicationStatus() {
        return applicationStatus;
    }
    public static get workflowStatusCode() {
        return workflowStatusCode;
    }
    public static get conceptNoteStatus() {
        return conceptNoteStatus;
    }
    public static get grantStatus() {
        return grantStatus;
    }
    public static get personnelHeaders() {
        return personnelHeaders;
    }
    public static get communicationPeriodHeaders() {
        return communicationPeriodHeaders;
    }
    public static get transactionHeaders() {
        return transactionHeaders;
    }
    public static get logframeworkSections() {
        return logframeworkSections;
    }
    public static get grantAgreementSections() {
        return grantAgreementSections;
    }
    public static get grantSummarySections() {
        return grantSummarySections;
    }
    public static get grantSummarySectionsAdmin() {
        return grantSummarySectionsAdmin;
    }
    public static get internalReviewTemplate() {
        return internalReviewTemplate;
    }
    public static get budgetConclusion() {
        return budgetConclusion;
    }
    public static get ddConclusion() {
        return ddConclusion;
    }
    public static get performanceStatus() {
        return performanceStatus;
    }
    public static get applicantDeclarationText() {
        return applicantDeclarationText;
    }
    public static get TagReviewDeclarationText() {
        return TagReviewDeclarationText;
    }
    public static get reportingFrequency() {
        return reportingFrequency;
    }
    public static get archiveHeadersAdmin()
    {
        return archiveHeadersAdmin;
    }
    public static get appRoles() {
        return appRoles;
    }
    public static get appUserType() {
        return appUserType;
    }
    public static get subjects() {
        return subjects;
    }
    public static get actions() {
        return actions;
    }
    public static get roles() {
        return roles;
    }
    public static get applicantEdiatableStatus() {
        return applicantEdiatableStatus;
    }
    public static get appicantEditableStatusCode() {
        return appicantEditableStatusCode;
    }
    public static get internalReviewAllowedStatus() {
        return internalReviewAllowedStatus;
    }
    public static get applicantDeleteStatus() {
        return applicantDeleteStatus;
    }
    public static get applicationAwardedStatus() {
        return  applicationAwardedStatus;     
    }
    public static get grantType() {
        return grantType;     
    }
    public static get menu() {
        return menu;
    }
    public static get reportingPeriods() {
        return reportingPeriods;
    }
    /** technical report status */
    public static get techReportStatus() {
        return techReportStatus;
    }
    public static get commReportStatus() {
        return commReportStatus;
    }
    /** financial report status */
    public static get finReportStatus() {
        return finReportStatus;
    }

    public static get finReportAuditStatus() {
        return finReportAuditStatus;
    }

    public static get migrationImportStatus() {
        return migrationImportStatus;
    }

    public static get Deadlines() {
        return Deadlines;
    }

    public static get FileSizeLimit() {
        return FileSizeLimit * 1024 * 1024;
    }

    public static get UserType() {
        return UserType;
    }
	public static get budgetMenuButtons() {
        return budgetMenuButtons;
    }
    public static get budgetReportSections() {
        return budgetReportSections;
    } 
    public static get defaultTimeFormat() {
        return defaultTimeFormat;
    } 
    public static get usefulDocHeaders(){
        return usefulDocHeaders
    }
    public static get migrationLogframeworkSections()
    {
        return migrationLogframeworkSections;
    }
    public static get commiunicationReportHeaders()
    {
        return commiunicationReportHeaders
    }
    public static get commiunicationHeadersAdmin()
    {
        return commiunicationHeadersAdmin
    }
    public static get updatePPO()
    {
        return updatePPO
    }
    public static get migrationTechnicalReportSections()
    {
        return migrationTechnicalReportSections;
    }
    public static get migrationsaveStatus()
    {
        return migrationsaveStatus;
    }
    public static get migrationGrantStatus()
    {
        return migrationGrantStatus;
    }
    public static get migrationStatus()
    {
        return migrationStatus;
    }
    public static get templateSections() {
        return templateSections;
    }
    public static get InitiativeCallType() {
        return InitiativeCallType;
    }
    public static get RouteAlias() {
        return RouteAlias;
    }
    public static get callType() {
        return callType;
    }
    public static get amendmentSections() {
        return amendmentSections;
    }
    public static get amendmentSubSections() {
        return amendmentSubSections;
    }
    public static get amendmentTypes() {
        return amendmentTypes;
    }
    public static get grantActionItems() {
        return grantActionItems;
    }
    public static get amendmentHeaders() {
        return amendmentHeaders;
    }
    public static get amendmentDetailsHeaders() {
        return amendmentDetailsHeaders;
    } 
    public static get logicalFrameworkHeaders() {
        return logicalFrameworkHeaders;
    }

    public static get preferredLanguage() {
        return preferredLanguage;
    }
    public static get reviewExternalRollbackStatus() {
        return reviewExternalRollbackStatus;
    }

    public static get reviewInternalRollbackStatus() {
        return reviewInternalRollbackStatus;
    }

    public static get reviewInternalConceptNoteRollbackStatus(){
        return reviewInternalConceptNoteRollbackStatus;
    }
}
